/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → error probability 1e-2 → 99% accuracy → Phred+33 char '5'.`)
};

const es_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → probabilidad de error 1e-2 → 99% de precisión → carácter Phred+33 '5'.`)
};

const de_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → Fehlerwahrscheinlichkeit 1e-2 → 99% Genauigkeit → Phred+33-Zeichen '5'.`)
};

const nl_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → foutkans 1e-2 → 99% nauwkeurigheid → Phred+33-teken '5'.`)
};

const fr_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → probabilité d'erreur 1e-2 → 99 % de précision → caractère Phred+33 '5'.`)
};

const it_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → probabilità di errore 1e-2 → 99% di accuratezza → carattere Phred+33 '5'.`)
};

const pt_br2_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → probabilidade de erro 1e-2 → 99% de precisão → caractere Phred+33 '5'.`)
};

const pt_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → probabilidade de erro 1e-2 → 99% de precisão → carácter Phred+33 '5'.`)
};

const ja_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → エラー確率1e-2 → 精度99% → Phred+33文字 '5'。`)
};

const zh_phred_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q20 → 错误概率 1e-2 → 99% 准确率 → Phred+33 字符 '5'。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_ex1", locale)
	if (locale === "en") return en_phred_ex1(inputs)
	if (locale === "es") return es_phred_ex1(inputs)
	if (locale === "de") return de_phred_ex1(inputs)
	if (locale === "nl") return nl_phred_ex1(inputs)
	if (locale === "fr") return fr_phred_ex1(inputs)
	if (locale === "it") return it_phred_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_phred_ex1(inputs)
	if (locale === "pt") return pt_phred_ex1(inputs)
	if (locale === "ja") return ja_phred_ex1(inputs)
	return zh_phred_ex1(inputs)
};